import { render, staticRenderFns } from "./AddRoleP4.vue?vue&type=template&id=091af34c&"
import script from "./AddRoleP4.vue?vue&type=script&lang=js&"
export * from "./AddRoleP4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports